import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlRecursosDestinacao = '/service/contabilidade/recursodestinacao/'

class RecursosDestinacaoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getRecursosDestinacao() {
        return this.conex.get(urlRecursosDestinacao + 'todos/')
    }
}

export default RecursosDestinacaoService
